import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit';
import { showApiErrors } from '@/utils';
import { getChannelLLMTemplate, resetChannelLLMTemplate, updateChannelLLMTemplate } from './actionCreators';
import { LLMChannelTemplateState, SLICE_NAME, initialState } from './models';

export const llmChannelTemplateSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addMatcher(
        isPending(getChannelLLMTemplate, updateChannelLLMTemplate, resetChannelLLMTemplate),
        (state: LLMChannelTemplateState) => {
          state.isLoading = true;
          state.error = null;
        },
      )
      .addMatcher(
        isFulfilled(getChannelLLMTemplate, updateChannelLLMTemplate, resetChannelLLMTemplate),
        (state: LLMChannelTemplateState, action) => {
          const { payload } = action;
          state.isLoading = false;
          state.template = payload;
        },
      )
      .addMatcher(
        isRejected(getChannelLLMTemplate, updateChannelLLMTemplate, resetChannelLLMTemplate),
        (state: LLMChannelTemplateState, action) => {
          const { error } = action;
          state.isLoading = false;
          state.error = error;
          showApiErrors(error);
        },
      );
  },
});
